import { render, staticRenderFns } from "./IconAbc.vue?vue&type=template&id=56babe07&"
import script from "./IconAbc.vue?vue&type=script&lang=js&"
export * from "./IconAbc.vue?vue&type=script&lang=js&"
import style0 from "./IconAbc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports